var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import clsx from "clsx";
// import useIndexDB from "@/hooks/useIndexDB";
import { makeStyles, useTheme } from "@mui/styles";
import { Box, Popover, Skeleton, Typography } from "@mui/material";
import useLoadSource from "@/hooks/useLoadSource";
var useStyles = makeStyles(function (theme) { return ({
    image: {
        opacity: 0,
        cursor: 'pointer',
        transition: 'opacity 1s ease-in-out',
    },
    loaded: {
        opacity: 1,
    },
}); });
export default (function (_a) {
    var _b, _c, _d;
    var _e, _f, _g, _h;
    var src = _a.src, caption = _a.caption, _j = _a.className, className = _j === void 0 ? undefined : _j, onClick = _a.onClick, props = __rest(_a, ["src", "caption", "className", "onClick"]);
    var classes = useStyles();
    var theme = useTheme();
    // const { getByIndex, add, update } = useIndexDB();
    var _k = React.useState(undefined), imgSrc = _k[0], setImgSrc = _k[1];
    var _l = React.useState(false), loaded = _l[0], setLoaded = _l[1];
    var getSource = useLoadSource({}).getSource;
    var _m = React.useState(null), anchorEl = _m[0], setAnchorEl = _m[1];
    var handlePopoverOpen = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handlePopoverClose = function () {
        setAnchorEl(null);
    };
    var open = Boolean(anchorEl);
    useEffect(function () {
        if (src) {
            getSource(src)
                .then(function (imgUrl) {
                setImgSrc(imgUrl);
            });
        }
    }, [src]);
    var handleImageLoad = function () {
        setLoaded(true);
    };
    if (!imgSrc) {
        return (_jsx(Box, __assign({}, props, { className: clsx((_b = {}, _b[className] = className, _b["MuiImageListItem-img"] = true, _b)), children: _jsx(Skeleton, { variant: "rectangular", width: "100%", height: "100%" }) })));
    }
    if (!caption) {
        return (_jsx("img", __assign({}, props, { onClick: onClick, src: imgSrc, className: clsx((_c = {}, _c[className] = className, _c[classes.image] = true, _c[classes.loaded] = loaded, _c["MuiImageListItem-img"] = true, _c)), onLoad: handleImageLoad })));
    }
    return (_jsxs(Box, { "aria-owns": open ? 'mouse-over-popover' : undefined, "aria-haspopup": "true", onMouseEnter: handlePopoverOpen, onMouseLeave: handlePopoverClose, onClick: onClick, sx: {
            cursor: 'pointer',
            p: 1,
            border: "1px solid transparent",
            transition: 'all .1s ease-in-out',
            '&:hover': {
                boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                position: 'relative',
                border: "1px solid ".concat((_f = (_e = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _e === void 0 ? void 0 : _e.primary) === null || _f === void 0 ? void 0 : _f.main)
            }
        }, children: [_jsx("img", __assign({}, props, { src: imgSrc, className: clsx((_d = {}, _d[className] = className, _d[classes.image] = true, _d[classes.loaded] = loaded, _d["MuiImageListItem-img"] = true, _d)), onLoad: handleImageLoad })), _jsx(Popover, { id: "mouse-over-popover", sx: { pointerEvents: 'none' }, slotProps: { paper: { elevation: 0, sx: { borderRadius: 0, width: 350, backgroundColor: (_h = (_g = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _g === void 0 ? void 0 : _g.primary) === null || _h === void 0 ? void 0 : _h.main } } }, open: open, anchorEl: anchorEl, anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                }, onClose: handlePopoverClose, disableRestoreFocus: true, children: _jsx(Typography, { variant: "body2", sx: { p: 1, color: '#FFF' }, children: caption }) })] }));
});
